<template>
  <div style="width: 100%">
    <div class="row">
      <div class="col-12 mt-4">
        <card class="custom-shadow-card-header">
          <div class="row">
            <select-component
              :class="`col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3`"
              :isMultiple="false"
              :dataOptions="farms"
              :requireClass="`required-farm`"
              :labelSelect="`${$t('common_words.farm')}: *`"
              :initialSelection="form.farm_id"
              @onChange="onFilterChange"
              modelName="farm_id"
            />
            <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-2">
              <label>{{ $t('common_words.year') }}: *</label>
              <br />
              <el-date-picker
                v-if="renderComponent"
                type="year"
                class="shadow-sm required-year"
                v-model="form.year_sel"
                value-format="yyyy"
                :picker-options="pickerOptions"
                :placeholder="`${$t('common_words.select2')}...`"
                @change="onYearChange(form.year_sel)"
              />
            </div>
            <div class="col-12 col-md-4 col-xl-2">
              <label class="label-primary" style="color: transparent">{{
                $t('common_words.filter')
              }}</label
              ><br />
              <l-button
                wide
                type="info"
                class="btn-filter"
                @click="validateSelectedFilters"
              >
                {{ $t('common_words.filter') }}
              </l-button>
            </div>
          </div>
          <br />
        </card>
        <card class="custom-shadow-card-header" v-if="isIndex() && showForm">
          <div class="row mt-2">
            <div class="col-12 col-sm-4 col-md-4 col-lg-2 col-xl-2">
              <el-button type="info" @click="toggleModal()">{{
                showModal
                  ? $t('common_words.manual_entry')
                  : $t('common_words.automatic_entry')
              }}</el-button>
            </div>
            <div
              class="col-12 col-sm-6 col-md-6 col-lg-10 col-xl-10 align-center-cell-flex"
            >
              <h6 class="text-muted">
                {{ $t('labor.cpa_schedule_farm') }} {{ farmSelected }}
              </h6>
            </div>
          </div>
          <br />
          <ScheduleTable
            :form="form"
            :weekList="weekList"
            :activities="activities"
            :activityUnits="activityUnits"
            :farmLots="farmLots"
            :farmLotsMultiple="farmLotsMultiple"
            :isPastWeekDisabled="isPastWeekDisabled"
            :isCoveredAreaDisabled="isCoveredAreaDisabled"
            @input-change="onInputChange"
            @week-selection-change="onWeekSelectionChange"
            @custom-selection-change="onCustomSelectionChange"
            @clear-week-selection="clearWeekSelection"
            @add-row="addScheduleRow"
            @remove-row="handleDelete"
          />
          <div class="row">
            <div class="col-6 text-right" v-if="isCreate() || isUpdate()">
              <l-button
                wide
                type="info"
                class="btn-filter m-4"
                @click="saveSchedule()"
              >
                {{
                  this.form.id
                    ? $t('common_words.update')
                    : $t('common_words.save')
                }}
              </l-button>
            </div>
            <div class="col-6 text-left" v-if="isDelete()">
              <l-button
                wide
                type="danger"
                class="btn-filter m-4"
                @click="removeSchedule()"
              >
                {{ $t('common_words.delete') }}
              </l-button>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import captureMethods from 'src/views/Pages/Dashboard/Work/CPA/capture-methods.js';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import ScheduleTable from 'src/views/Pages/Dashboard/Work/CPA/ScheduleTable.vue';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [ScheduleTable.name]: ScheduleTable,
  },

  data() {
    return {
      showForm: false,
      showModal: true,
      farmSelected: null,
      form: {
        id: null,
        farm_id: null,
        year_sel: null,
        user_id: this.$store.state.auth.user.id,
        unit: [],
        activity: [],
        lot: [],
        custom: [false],
        covered_area: [null],
        lot_quantities: [{}],
        execution_weeks: [null],
        weeks: [[]],
        nCatchs: 1,
      },
      farms: [],
      farmLots: [],
      farmLotsMultiple: [],
      weekList: [],
      activities: [],
      activityUnits: [],
      pickerOptions: {
        disabledDate(time) {
          const currentYear = new Date().getFullYear();
          const selectedYear = new Date(time).getFullYear();

          return selectedYear < currentYear;
        },
      },
    };
  },

  mixins: [mixinMasters, MixinPermissions, MixinExport, MixinMenu, MixinForm],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  // created() {
  //   if (this.isIndex()) {
  //     this.showHideLoading(true);
  //     Axios.getMasters('farms/farms/onlyfruit')
  //       .then((response) => {
  //         this.farms = response.data.data;
  //         this.showHideLoading();
  //       })
  //       .catch((error) => {
  //         this.showHideLoading();
  //         SweetAlert.warning(error.response.data.message);
  //       });
  //     Axios.getMasters('works/activities?with_trashed=0')
  //       .then((response) => {
  //         this.activities = response.data.data.map((activity) => ({
  //           ...activity,
  //           name: `${activity.code} - ${activity.name} - ${activity.activity_unit_payment.abbreviation}`,
  //         }));
  //       })
  //       .catch((error) => {
  //         SweetAlert.warning(error.response.data.message);
  //       });
  //     Axios.getMasters('works/activityunits/field')
  //       .then((response) => {
  //         this.activityUnits = response.data.data;
  //       })
  //       .catch((error) => {
  //         SweetAlert.warning(error.response.data.message);
  //       });
  //   } else {
  //     this.showHideLoading();
  //   }
  // },
  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('farms/farms/onlyfruit'),
        Axios.getMasters('works/activities?with_trashed=0'),
        Axios.getMasters('works/activityunits/field'),
      ])
        .then(([responseFarms, responseActivities, responseUnits]) => {
          this.farms = responseFarms.data.data;
          this.activities = responseActivities.data.data.map((activity) => ({
            ...activity,
            name: `${activity.code} - ${activity.name} - ${activity.activity_unit_payment.abbreviation}`,
          }));
          this.activityUnits = responseUnits.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  /**
   * Antes de que se cree el componente, este método enlaza automáticamente
   * todos los métodos extraídos desde `captureMethods.js` al contexto del
   * componente (`this`). Esto permite que los métodos importados conserven
   * el acceso a las propiedades reactivas y demás funcionalidades de Vue.
   */
  beforeCreate() {
    Object.entries(captureMethods()).forEach(([key, fn]) => {
      this[key] = fn.bind(this);
    });
  },

  mounted() {
    this.selectedItemOnMenu('works');
  },

  destroyed() {
    this.deselectedItemOnMenu('works');
  },
};
</script>
